import React from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import {
  Heading2,
  Label,
  LeftHalfLayout,
  RightHalfLayout,
  Flex,
  Panel,
  TextInput
} from '@sopranodesign/pulse-components';
import { TopSection } from '@sopranodesign/pulse-tickets';

import { getName } from '../LogName';
import LogLevel from '../LogLevel';
import LogDescription from '../LogDescription';

const FailedJobContent = ({
  subscriber,
  created_at,
  description,
  content,
  level,
  type
}) => (
  <Panel>
    <Flex col mb>
      <TopSection center>
        <LogLevel level={level} />
        <Heading2>{getName({ level, type })}</Heading2>
      </TopSection>
      <Label secondary>
        {dayjs(created_at).from(dayjs())} by{' '}
        {subscriber ? `Subscriber #${subscriber.id}` : 'N/A'}
      </Label>
    </Flex>
    <Flex>
      {!content ? (
        <LogDescription description={description} />
      ) : (
        <>
          <LeftHalfLayout>
            <LogDescription description={description} />
          </LeftHalfLayout>
          <RightHalfLayout>
            <div>
              <Label>Job</Label>
              <TextInput value={content.job ?? 'N/A'} disabled />
            </div>
            <div>
              <Label>Error</Label>
              <TextInput value={content.message ?? 'N/A'} disabled />
            </div>
          </RightHalfLayout>
        </>
      )}
    </Flex>
  </Panel>
);

FailedJobContent.propTypes = {
  subscriber: PropTypes.shape({
    id: PropTypes.number
  }),
  created_at: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  level: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  content: PropTypes.shape({
    job: PropTypes.string,
    message: PropTypes.string
  })
};

export default FailedJobContent;
